import { render, staticRenderFns } from "./DefaultRadio.vue?vue&type=template&id=00f0cf70&"
import script from "./DefaultRadio.vue?vue&type=script&lang=js&"
export * from "./DefaultRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports